// extracted by mini-css-extract-plugin
module.exports = {"quickCartItem__main":"quickCartItem_quickCartItem__main__1HnAu","item__delete__BTN":"quickCartItem_item__delete__BTN__13S92","item__img":"quickCartItem_item__img__2EtPq"};